import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { FunctionComponent } from 'react';

interface JoinTinderDialogProps {
  open: boolean;
  onCancel: () => void;
  onJoin: () => void;
}

export const JoinTinderDialog: FunctionComponent<JoinTinderDialogProps> = ({
  open,
  onCancel,
  onJoin,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="join-tinder-dialog-title"
      aria-describedby="join-tinder-dialog-description"
    >
      <DialogTitle id="join-tinder-dialog-title">
        {"S'inscrire au Meetic"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="join-tinder-dialog-description">
          {
            "En rejoignant le Meetic, vous avez conscience que ce n'est qu'un jeu fun pour rencontrer les autres congressistes en avance, et non un vrai site de rencontre. Vous pouvez quitter le jeu à tout moment et vos likes/matches seront supprimés."
          }
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Annuler</Button>
        <Button onClick={onJoin} autoFocus variant="contained">
          {"M'inscrire"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
